<template>
  <div v-loading="loading">
    <div
      class="new-content-detail-card-title flex-between-center"
      :class="[companiesType == 1 ? 'margin-b40' : 'margin-b20']"
    >
      <div class="flex-center-start">
        <span class="own_title">Ownership</span>
        <!-- <div v-if="companiesType == 1 && companiesEchartsType == 1">
          <el-button
            class="echarts-add-icon"
            :disabled="level >= 3 || companiesEchartsType == 0"
            @click="changeLevel('plus')"
            ><i class="iconfont icon-tianjia1"></i
          ></el-button>
          <el-button
            class="echarts-minus-icon"
            :disabled="level <= 1 || companiesEchartsType == 0"
            @click="changeLevel('minus')"
            ><i class="iconfont icon-jian"></i
          ></el-button>
        </div> -->
      </div>
      <div class="flex-center-start">
        <TabIcon
          v-if="companiesType == 1"
          :currentIndex="companiesEchartsType"
          icon1="icon-guanxichaxunyoushangguanxi"
          icon2="icon-zuzhi"
          class="margin-r20"
          @onTabIcon="onTabCompaniesEcharts"
        ></TabIcon>
        <TabIcon ref="tabRef" @onTabIcon="onTabCompanies"></TabIcon>
      </div>
    </div>
    <!--related Companies 表格模式  -->
    <template v-if="companiesType == 0">
      <div class="new-table-box new-table-small-box" key="companiesData">
        <el-table
          :data="companiesData"
          row-key="id"
          class="new-table-con"
        >
          <el-table-column
            prop="name"
            label="Name"
            min-width="300"
            class-name="hover-cell"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.id3a
                    .split('')
                    .every((char) => char >= '0' && char <= '9')
                "
                class="link-text hover-text"
                @click="onOpenLinkPage(scope.row)"
                >{{ scope.row.name ? scope.row.name : "-" }}</span
              >
              <template v-else>{{
                scope.row.name ? scope.row.name : "-"
              }}</template>
            </template>
          </el-table-column>
          <el-table-column
            prop="country"
            label="Country"
            min-width="180"
            class-name="two-column-cell"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.country ? scope.row.country : "-" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="location"
            label="Location"
            min-width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{
              scope.row.location ? scope.row.location : "-"
            }}</template>
          </el-table-column>
          <el-table-column
            prop="type"
            :label="$t('Ownership.Type')"
            min-width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{
              scope.row.type ? scope.row.type : "-"
            }}</template>
          </el-table-column>
          <el-table-column
            prop="shares"
            label="Shares(%)"
            min-width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{
              scope.row.shares ? scope.row.shares : "-"
            }}</template>
          </el-table-column>
          <el-table-column
            prop="relations"
            label="Relations"
            width="200"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{
              scope.row.relations ? scope.row.relations : "-"
            }}</template>
          </el-table-column>
        </el-table>
      </div>
      <Page
        keyword="Investments"
        :total="companiesTotalCount"
        :pageSize="companiesParams.pageSize"
        :currentPage="companiesParams.page"
        @onPageChange="onChangeCompaniesPage"
      ></Page>
    </template>
    <!-- 关系图 -->
    <div
      class="ownership-graph-con"
      v-show="companiesType == 1 && companiesEchartsType == 1"
    >
      <!--关系图左边表格  -->
      <div class="ownership-graph-left">
        <div class="ownership-graph-left-item flex-center-start">
          <div class="ownership-graph-left-name">
            Ultimate Beneficiary Owner
          </div>
          <div class="ownership-graph-left-desc">
            {{ shareholderChartSummaryObject?.ultimateBeneficiary }}
          </div>
        </div>
        <div class="ownership-graph-left-item flex-center-start">
          <div class="ownership-graph-left-name">Shareholding Layers</div>
          <div class="ownership-graph-left-desc">
            {{ shareholderChartSummaryObject?.shareholdingLayers }}
          </div>
        </div>
        <div class="ownership-graph-left-item flex-center-start">
          <div class="ownership-graph-left-name">Parties Involved</div>
          <div class="ownership-graph-left-desc">
            {{ shareholderChartSummaryObject?.partiesInvolved }}
          </div>
        </div>
        <div class="ownership-graph-left-item flex-center-start">
          <div class="ownership-graph-left-name">Related Company</div>
          <div class="ownership-graph-left-desc">
            {{ shareholderChartSummaryObject?.relatedCompany }}
          </div>
        </div>
        <div class="ownership-graph-left-item flex-center-start">
          <div class="ownership-graph-left-name">Company Shareholders</div>
          <div class="ownership-graph-left-desc">
            {{ shareholderChartSummaryObject?.companyShareholders }}
          </div>
        </div>
        <div class="ownership-graph-left-item flex-center-start">
          <div class="ownership-graph-left-name">NGO Shareholders</div>
          <div class="ownership-graph-left-desc">
            {{ shareholderChartSummaryObject?.ngoShareholders }}
          </div>
        </div>
        <div class="ownership-graph-left-item flex-center-start">
          <div class="ownership-graph-left-name">
            Natural Person Shareholder
          </div>
          <div class="ownership-graph-left-desc">
            {{ shareholderChartSummaryObject?.naturalPersonShareholder }}
          </div>
        </div>
        <div class="ownership-graph-left-item flex-center-start">
          <div class="ownership-graph-left-name">Subject's Investments</div>
          <div class="ownership-graph-left-desc">
            {{ shareholderChartSummaryObject?.subjectInvestments }}
          </div>
        </div>
      </div>
      <!-- 关系图 -->
      <div class="companies-graph-echarts" ref="companiesChart"></div>
      <div class="graph_controls" v-if="companiesType == 1 && companiesEchartsType == 1">
        <button class="btn_control" :disabled="level >= 3 || companiesEchartsType == 0" @click="changeLevel('plus')">
          <i class="iconfont icon-fangda" />
        </button>
        <button class="btn_control" :disabled="level <= 1 || companiesEchartsType == 0" @click="changeLevel('minus')">
          <i class="iconfont icon-suoxiao" />
        </button>
      </div> 
    </div>

    <!-- d3股东图 -->
    <div
      class="equity-d3-con"
      v-show="companiesType == 1 && companiesEchartsType == 0"
    >
      <EquityD3
        key="Ownership"
        :chartData="chartData"
        chartType="risk"
        v-if="companiesEchartsType == 0"
      ></EquityD3>
    </div>
    <Tips :dialogVisible.sync="isShowTips"></Tips>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import Page from "@/views/newLayout/page.vue";
import TabIcon from "@/views/newLayout/tabIcon.vue";
import Header from "@/views/newLayout/header.vue";
import Tollbar from "@/views/newLayout/tollbar.vue";
import Tips from "@/views/newLayout/tips.vue";
import EquityD3 from "@/views/company/details/Background/componet/index.vue";
import {
  formatterTxt,
  formatListMax50,
} from "@/views/company/details/Background/utils";
import {
  getOwnership,
  getShareholderChartSummary,
  getCompanyCharttwo,
  getCompanyDetailchirt,
  getPartPrivilege,
} from "@/api/companyApi";
export default {
  mixins: [mixins1],
  components: {
    Header,
    Tollbar,
    Page,
    TabIcon,
    EquityD3,
    Tips,
  },
  data() {
    return {
      isShowTips: false,
      powerArr: [],
      level: 1,
      level1: 1,
      loading: false,
      companiesType: 0,
      companiesEchartsType: 1,
      companiesParams: {
        page: 1, // 当前页数
        pageSize: 5, // 每页加载的数据条数
      },
      companiesData: [],
      companiesTotalCount: 0,
      companiesEchart: "",
      shareholderChartSummaryObject: {},
      echartsdate: [],
      chartData: null,
      comIcon1: "image://" + require("@/assets/img/echarts/comIcon1.png"),
      comIcon2: "image://" + require("@/assets/img/echarts/WechatIMG31.png"),
      comIcon3: "image://" + require("@/assets/img/echarts/comIcon3.png"),
      comIcon4: "image://" + require("@/assets/img/echarts/comIcon4.png"),
      comIcon5: "image://" + require("@/assets/img/echarts/comIcon5.png"),
    };
  },
  methods: {
    // Related Companies分页切换
    onChangeCompaniesPage(params) {
      this.companiesParams = params;
      this.getlistData();
    },
    // Related Companies tab切换
    onTabCompanies(type) {
      if (this.powerArr[0]?.hasPrivilege) {
        this.companiesType = type;
        if (type == 1) {
          this.$nextTick(() => this.showEcahrt());
        }
      } else {
        this.companiesType = 0;
        this.$refs.tabRef.returnIndex(0);
        this.isShowTips = true;
      }
    },
    // Related Companies echarts tab切换
    onTabCompaniesEcharts(type) {
      this.companiesEchartsType = type;
      if (type == 0) {
      }
      if (type == 1) {
        this.$nextTick(() => this.showEcahrt());
      }
    },
    // echarts1
    add(list) {
      list.forEach(async (item) => {
        if (!item.children.length) {
          if (item.code) {
            const params = {
              id3a: item.code,
              page: "1",
              pageSize: "5",
            };
            const res = await getCompanyCharttwo(params);
            let ecahrtsdata = res;
            ecahrtsdata = JSON.parse(
              JSON.stringify(ecahrtsdata).replace(/subsetList/g, "children"),
            );
            if (ecahrtsdata && ecahrtsdata.code) {
              this.loading = false;
              this.getList(
                this.echartsdate.children,
                item.code,
                ecahrtsdata.data.children,
              );
              this.setEchartList();
              this.$nextTick(() => this.showEcahrt());
            } else {
            }
          }
        } else {
          this.add(item.children);
        }
      });
    },
    // Related Companies 关系图加减操作
    changeLevel(type) {
      if (type === "plus") {
        this.level++;
        this.level1++;
        this.level1 > 4 ? (this.level1 = 4) : this.level11;

        // 点加号按钮寻找当前数组的最外层children
        let that = this;
        if (this.level >= 2) {
          if (this.level1 < 4) {
            that.add(that.echartsdate.children);
          }
        }
      }

      if (type === "minus") this.level--;
      this.$nextTick(() => this.showEcahrt());
    },
    // 递归获取数组
    getList(list, code, newVal) {
      list.forEach((item, index) => {
        if (list[index].code === code) {
          list[index].children = newVal;
        } else if (list[index].children && list[index].children.length > 0) {
          this.getList(list[index].children, code, newVal);
        }
      });
    },
    // Related Companies 关系图数据
    async echartslist() {
      this.loading = true;
      const params = {
        id3a: this.$route.query.id3a,
        page: "1",
        pageSize: "10",
      };
      const res = await getCompanyCharttwo(params);
      const ecahrtsdata = res;
      if (ecahrtsdata && ecahrtsdata.code) {
        this.echartsdate = ecahrtsdata.data;
        this.setEchartList();
        // console.log("*", this.echartData);
        // this.$nextTick(() => this.showEcahrt());
      }
      this.loading = false;
    },
    setEchartList(echartsdate = this.echartsdate) {
      const echartData = echartsdate.subsetList || []; // 股东list

      const data = {
        name: this.echartsdate.name,
        nameEn: this.echartsdate.nameEn,
        code: this.echartsdate.code,
        companyType: this.echartsdate.companyType,
        countryCode: this.echartsdate.countryCode,
        type: this.echartsdate.type,
        legalStatus: this.echartsdate.legalStatus,
        children: [],
      };
      const childrenList = formatListMax50(
        echartData,
        this.companyAaaid,
        this.companyAaaid,
      );
      data.children = childrenList;
      if (childrenList && childrenList.length > 0) {
        this.getLevel2Children(data, this.companyAaaid);
      } else {
        this.echartData = data;
      }
    },
    getLevel2Children(vals = data, aaaid) {
      const echartData = vals;

      echartData.children.map((item, index) => {
        if (item.isMax == aaaid) {
          const echartData = item.subsetList || [];
          const subsetList = formatListMax50(
            echartData,
            this.companyAaaid,
            this.companyAaaid,
          );
          item.subsetList = subsetList;
        }
      });
      this.echartsdate = echartData;
    },
    // Related Companies echarts
    async showEcahrt() {
      if (!this.companiesEchart) {
        this.companiesEchart = this.$echarts.init(this.$refs.companiesChart);
        await this.$nextTick();
      }
      const that = this;
      let leval = that.level;
      const initialTreeDepth = leval;
      that.echartsdate = JSON.parse(
        JSON.stringify(that.echartsdate).replace(/subsetList/g, "children"),
      );
      let data = that.echartsdate;
      const symbol = (data) => {
        if (`${data.invtypecode}` === "3") {
          // 外国公司
          return this.comIcon3;
        }
        if (`${data.invtypecode}` === "5") {
          // 国营企业
          return this.comIcon5;
        }

        if (`${data.code}` === this.$route.query.id3a) {
          return this.comIcon4;
        }
        if (data.type == "2") {
          // 个人
          return this.comIcon2;
        }
        return this.comIcon1;
      };
      const option = {
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
          fontSize: 12,
          formatter: (params) => formatterTxt(params),
        },
        series: [
          {
            type: "tree",
            data: [data],
            top: "18%",
            bottom: "14%",
            // roam: true,
            clickable: true,

            layout: "radial",
            symbol: (value, param) => symbol(param.data),
            symbolSize: 30,
            initialTreeDepth,
            animationDurationUpdate: 750,
            emphasis: {
              focus: "ancestor",
            },
            orient: "TB",
            label: {
              fontSize: 9,
              formatter: (params) => formatterTxt(params),
              rotate: 360,
            },
            leaves: {
              label: {
                fontSize: 9,
                formatter: (params) => formatterTxt(params),
                rotate: 360,
              },
            },
          },
        ],
      };

      this.companiesEchart.setOption(option);
    },
    //   股东图
    getCompanyDetailchirtList() {
      this.loading = true;
      getCompanyDetailchirt({
        id3a: this.$route.query.id3a,
        page: "1",
        pageSize: "50",
      }).then((Res) => {
        if (Res.code == 200) {
          let ecahrtsdata = Res.data;

          ecahrtsdata = JSON.parse(
            JSON.stringify(ecahrtsdata).replace(/name/g, "entname"),
          );
          ecahrtsdata = JSON.parse(
            JSON.stringify(ecahrtsdata).replace(/entnameNative/g, "entnameen"),
          );

          this.chartData = ecahrtsdata;
          this.chartData = JSON.parse(
            JSON.stringify(this.chartData).replace(/shareholders/g, "parents"),
          );
        }
      });
      this.loading = false;
    },
    // 列表数据
    getlistData() {
      const id3a = this.$route.query.id3a;
      getOwnership({
        id3a: id3a,
        ...this.companiesParams,
      })
        .then((Res) => {
          if (Res.code == 200) {
            this.companiesData = Res.data.rows;
            this.tableDatamap = Res.data.rows;
            this.companiesTotalCount = Res.data.total;
          } else {
            this.companiesData = [];
          }
          this.$emit("onOwnershipTotal", this.companiesTotalCount);
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    // Ownership 关系图左侧数据
    async getShareholderChartSummaryList() {
      this.loading = true;
      const id3a = this.$route.query.id3a;
      let res = await getShareholderChartSummary({
        id3a: id3a,
      });
      if (res.code == 200) {
        this.shareholderChartSummaryObject = res.data;
      }
      this.loading = false;
    },
    getPartPrivilege() {
      getPartPrivilege({
        moduleId: "404",
      }).then((res) => {
        this.powerArr = res.data.filter((item) => item.id == "406");
      });
    },
    // 打开外面链接
    onOpenLinkPage(row) {
      let companyCountryEn = "";

      let routeData = this.$router.resolve({
        path:
          "/index/company/details/" +
          row.id3a +
          "/background/snapshot?id3a=" +
          row.id3a +
          "&companyCountry=" +
          "" +
          "&companyCountryEn=" +
          companyCountryEn +
          "&keword=" +
          this.$route.query.keword,
      });

      window.open(routeData.href, "_blank");
    },
  },
  mounted() {
    this.getPartPrivilege();
    this.getlistData();
    this.getShareholderChartSummaryList();
    this.echartslist();
    this.getCompanyDetailchirtList();
  },
};
</script>
<style scoped>
.new-table-box.new-table-small-box
  >>> .el-table
  .el-table__body-wrapper
  .el-table__row:nth-child(5)
  td {
  border-bottom: none;
}

.companies-graph-echarts {
  flex: 1;
  height: 746px;
}
.equity-d3-con {
  height: 680px;
}
.ownership-graph-con {
  display: flex;
  align-items: start;
  position: relative;
}
.ownership-graph-left {
  width: auto;
  height: auto;
  margin-right: 200px;
}
.ownership-graph-left-item {
  height: 80px;
  line-height: 80px;
  border-bottom: 1px solid #cccccc;
}
.ownership-graph-left-item:first-child {
  border-top: 1px solid #cccccc;
}
.ownership-graph-left-name {
  width: 280px;
  height: 100%;
  padding-left: 20px;
  font-family: "Arial Bold";
  font-size: 18px;
  background: #f3f3f3;
}
.ownership-graph-left-desc {
  width: 260px;
  line-height: 22px;
  font-size: 18px;
  text-align: center;
}
.echarts-add-icon,
.echarts-minus-icon {
  width: 32px;
  height: 32px;
  padding: 0;
  background: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
.echarts-add-icon i,
.echarts-minus-icon i {
  color: #1a2332;
}
.echarts-add-icon {
  margin-left: 30px;
}
.echarts-minus-icon {
  margin-left: 20px;
}
.graph_controls {
  position: absolute;
  right: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 40px;
  padding: 20px 0;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.btn_control {
  width: 40px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  background-color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 24px;
  font-weight: 500;
  transition: all 0.3s;
}

.btn_control i {
  font-size: 20px;
}
.btn_control:hover {
  background-color: #f0f0f0;
  border-color: #999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.btn_control:active {
  background-color: #e0e0e0;
}
@media (max-width: 1920px) {
  .companies-graph-echarts {
    height: 498px;
  }
  .equity-d3-con {
    height: 454px;
  }
  .ownership-graph-left {
    margin-right: 140px;
  }
  .ownership-graph-left-item {
    height: 54px;
    line-height: 54px;
  }
  .ownership-graph-left-name {
    width: 186px;
    padding-left: 14px;
    font-size: 16px;
  }
  .ownership-graph-left-desc {
    width: 173px;
    line-height: 16px;
    font-size: 16px;
  }
  .echarts-add-icon,
  .echarts-minus-icon {
    width: 22px;
    height: 22px;
    border-radius: 3px;
  }
  .echarts-add-icon i,
  .echarts-minus-icon i {
    font-size: 12px;
  }
  .echarts-add-icon {
    margin-left: 20px;
  }
  .echarts-minus-icon {
    margin-left: 14px;
  }
  .flex-center-start{
    justify-content: center;
  }
  .own_title{
    font-family: 'Arial Bold';
  }
}
</style>
